import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const WidgetWrapper = styled.div`
  position: relative;
  width: ${({ scale }) => `${scale * 100}%`};
  height: ${({ scale }) => `${scale * 150}px`};
`;

const TrustpilotMiniWidget = ({
  theme = "light",
  scale = 1,
  centered = false,
  ...props
}) => {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const ref = useRef(null);

  useEffect(() => {
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, []);

  return (
    <WidgetWrapper {...props} scale={scale}>
      <div
        ref={ref}
        className="trustpilot-widget"
        data-locale={lang}
        data-template-id="53aa8807dec7e10d38f59f32"
        data-businessunit-id="649c37bc30c02f53aca7db29"
        data-style-height="150px"
        data-style-width="100%"
        data-theme={theme}
      >
        <a
          href="https://nl.trustpilot.com/review/hetvleescentrum.nl"
          target="_blank"
          rel="noopener"
        >
          Trustpilot
        </a>
      </div>
    </WidgetWrapper>
  );
};

export default TrustpilotMiniWidget;
